export enum ReleaseRightEnum {
  Reject = 0,
  Accept = 1,
  Transfer = 2,
  Revoke = 3
}